import type Handle from 'dxf-writer/src/Handle.js'
import TextStyle from 'dxf-writer/src/TextStyle.js'
import { LineType } from '@/plugins/cad/module/CADModule/model/common/constant'
import LineTypeConstructor from './LineType'

/** DXF 内置基础线型定义列表，写入 LTYPE 表段 */
export const DXFLineTypes = [
  { name: 'CONTINUOUS', description: '______', elements: [] },
  { name: 'DASHED', description: '_ _ _ ', elements: [1.0, -0.5] },
  { name: 'DASHDOT', description: '_ . _ . _', elements: [1.0, -0.25, 0.0, -0.25] },
]

/** CAD 业务线型枚举到 DXF 线型名的映射表 */
export const LineTypeMapping = {
  [LineType.Solid]: 'CONTINUOUS',
  [LineType.Dash]: 'DASHED',
  [LineType.DashDot]: 'DASHDOT',
  [LineType.DoubleDash]: 'DOUBLEDASH',
  default: 'CONTINUOUS',
}

/** 默认标注样式名称 */
export const DimStyleName = 'Standard'

/** CAD 标准线宽集合，单位毫米；用于判定实体线宽是否合法 */
// CAD标准线宽列表（单位：毫米）
export const CADStandardLineWidth = new Set<number>([
  0.0, 0.05, 0.09, 0.13, 0.15, 0.18, 0.2, 0.25, 0.3, 0.35, 0.4, 0.5, 0.53, 0.6, 0.7, 0.8, 0.9, 1.0,
  1.06, 1.2, 1.4, 1.58, 2.0, 2.11,
])

/**
 * DXF 线宽的三个特殊取值。
 */
export enum DXFLineWidth {
  /** 跟随图层线宽 */
  ByLayer = -1,
  /** 跟随块线宽 */
  ByBlock = -2,
  /** 使用系统默认线宽 */
  Default = -3,
}

/**
 * 构造复杂线型共用的形状 TextStyle。
 *
 * @returns 指向 ltypeshp 字形文件的 TextStyle 实例
 */
export function getShapeStyle() {
  const shapeStyle = new TextStyle('ShapeStyle')
  shapeStyle.fontFileName = 'ltypeshp'
  return shapeStyle
}

/**
 * 构造自定义双划线复杂线型 DOUBLEDASH。
 *
 * @param styleHandle - 关联的形状样式句柄，用于嵌入字符
 * @returns 可注册到 Drawing 的 LineType 实例
 */
export function getComplexLineType(styleHandle: Handle) {
  return new LineTypeConstructor('DOUBLEDASH', '-_-_', [
    {
      length: 0.5,
      tags: (manager) => {
        manager.push(74, 2) // 复杂线型元素 2-嵌入字符串
        manager.push(75, 0)
        manager.push(340, styleHandle)
        manager.push(46, 0.75) // 比例值
        manager.push(50, 0.0) // 旋转角度
        manager.push(44, 0.0) // X偏移值
        manager.push(45, -0.52) // Y偏移值
        manager.push(9, '-')
      },
    },
    {
      length: -0.5,
      tags: (manager) => {
        manager.push(74, 0)
      },
    },
  ])
}
